import React from 'react';
import { useSolutionsHeroContent } from '../../../../hooks/useSolutionsHeroContent';
import './Hero.css';

const renderMultilineText = (text) =>
  text.split('\n').map((line, index, lines) => (
    <React.Fragment key={`${line}-${index}`}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));

const Hero = () => {
  const { content, isLoading } = useSolutionsHeroContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, text, backgroundImage } = content;

  return (
    <section className="solutions-hero">
      <img
        className="solutions-hero__bg"
        src={backgroundImage}
        alt=""
        aria-hidden="true"
      />
      <div className="solutions-hero__overlay" />

      <div className="solutions-hero__inner">
        <div className="solutions-hero__content">
          {eyebrow ? <p className="solutions-hero__eyebrow">{eyebrow}</p> : null}
          <h1 className="solutions-hero__title">{renderMultilineText(title)}</h1>
          {text ? <p className="solutions-hero__text">{text}</p> : null}
        </div>
      </div>
    </section>
  );
};

export default Hero;
